











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ImageModal extends Vue {
  @Prop({ type: String })
  val!: string;

  private mounted() {
    (this.$refs.overlay as Element).addEventListener("click", e => {
      if (this.$refs.img !== e.target) {
        this.$emit("close");
      }
    });
  }
}
